import { useState } from "react";
import { ChevronsLeftRight } from "lucide-react";
import useI18n from "@/i18n";

/*
 * Comparateur avant / après : glisser à la souris, au doigt
 * ou aux flèches du clavier (input range accessible superposé).
 */
export default function BeforeAfter({
    id,
    title,
    note,
    beforeSrc,
    afterSrc,
    beforeAlt,
    afterAlt,
}) {
    const { t } = useI18n();
    const [pos, setPos] = useState(50);

    return (
        <figure className="ba m-0" data-testid={`before-after-${id}`}>
            <div className="ba-frame">
                <picture>
                    <source srcSet={afterSrc.replace(".jpg", ".webp")} type="image/webp" />
                    <img
                        src={afterSrc}
                        alt={afterAlt}
                        loading="lazy"
                        className="ba-img"
                        data-testid={`ba-after-${id}`}
                    />
                </picture>
                <picture>
                    <source srcSet={beforeSrc.replace(".jpg", ".webp")} type="image/webp" />
                    <img
                        src={beforeSrc}
                        alt={beforeAlt}
                        loading="lazy"
                        className="ba-img"
                        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
                        data-testid={`ba-before-${id}`}
                    />
                </picture>
                <span className="ba-tag ba-tag-l">{t.beforeAfter.before}</span>
                <span className="ba-tag ba-tag-r">{t.beforeAfter.after}</span>
                <div className="ba-line" style={{ left: `${pos}%` }} aria-hidden="true">
                    <span className="ba-knob">
                        <ChevronsLeftRight size={15} strokeWidth={2.2} />
                    </span>
                </div>
                <input
                    type="range"
                    min="0"
                    max="100"
                    step="1"
                    value={pos}
                    onChange={(e) => setPos(Number(e.target.value))}
                    className="ba-range"
                    aria-label={`${t.beforeAfter.compare} ${title}`}
                    data-testid={`ba-range-${id}`}
                />
            </div>
            <figcaption className="mt-4">
                <h3 className="text-lg text-olivet">{title}</h3>
                <p className="mt-1 text-sm" style={{ color: "var(--c-ink2)" }}>
                    {note}
                </p>
            </figcaption>
        </figure>
    );
}
